module.exports = __webpack_public_path__ + "img/vmc_aniv1_24Aug2021.9b7c15ef.jpg";